import { DynamicFormControlLayout, DynamicFormControlModelConfig, DynamicFormValueControlModel, serializable } from '@ng-dynamic-forms/core';

export const TYPE_NACHRICHTENVERLAUF = 'NACHRICHTENVERLAUF';

export interface NachrichtenverlaufModelConfig extends DynamicFormControlModelConfig {
  icon?: string;
  heading?: string;
  timestamp?: string[];
}

export class NachrichtenverlaufModel extends DynamicFormValueControlModel<any> {
  @serializable() readonly type: string = TYPE_NACHRICHTENVERLAUF;
  @serializable() icon: string;
  @serializable() heading: string;

  constructor(config: NachrichtenverlaufModelConfig, layout?: DynamicFormControlLayout) {
    super(config, layout);

    this.icon = config.icon || 'print';
    this.heading = config.heading || null;
  }
}
